import React from "react";
import { formatINR } from "../api";
import { useSiteConfig, saleUnit } from "../context/SiteConfigContext";

/**
 * Price display. When a site-wide sale is active, shows the discounted price
 * in copper with the original struck through.
 */
const Price = ({ price, qty = 1, className = "", size = "base" }) => {
  const { discount } = useSiteConfig();
  const unit = Number(price) || 0;
  const sale = saleUnit(unit, discount);
  const onSale = discount?.active && sale < unit;

  if (!onSale) {
    return <span className={className}>{formatINR(unit * qty)}</span>;
  }

  const strikeCls = size === "lg"
    ? "text-base text-[var(--espresso)]/45 line-through mr-2"
    : "text-xs text-[var(--espresso)]/45 line-through mr-2";

  return (
    <span className={className} data-testid="price-sale">
      <s className={strikeCls}>{formatINR(unit * qty)}</s>
      <span className="text-[var(--copper)]">{formatINR(sale * qty)}</span>
    </span>
  );
};

export default Price;
